module.exports = __webpack_public_path__ + "static/img/bannerIn.4e110be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/beginnersOnly/bannerIn.png
// module id = ddDg
// module chunks = 0